// GENERATED by scripts/optimize-images.mjs — do not edit by hand.
// Run `pnpm run optimize:images` to regenerate.

import type { ImageManifest } from './imageManifest.types';

export const imageManifest: ImageManifest = {
  '/assets/images/product-photos/chow-chow.png': {
    width: 1254,
    height: 1254,
    avif: [
      { width: 480, src: '/assets/images/product-photos/chow-chow-480.avif' },
      { width: 768, src: '/assets/images/product-photos/chow-chow-768.avif' },
      { width: 1200, src: '/assets/images/product-photos/chow-chow-1200.avif' },
      { width: 1254, src: '/assets/images/product-photos/chow-chow-1254.avif' },
    ],
    webp: [
      { width: 480, src: '/assets/images/product-photos/chow-chow-480.webp' },
      { width: 768, src: '/assets/images/product-photos/chow-chow-768.webp' },
      { width: 1200, src: '/assets/images/product-photos/chow-chow-1200.webp' },
      { width: 1254, src: '/assets/images/product-photos/chow-chow-1254.webp' },
    ],
  },
  '/assets/images/product-photos/karakonjul.png': {
    width: 1254,
    height: 1254,
    avif: [
      { width: 480, src: '/assets/images/product-photos/karakonjul-480.avif' },
      { width: 768, src: '/assets/images/product-photos/karakonjul-768.avif' },
      { width: 1200, src: '/assets/images/product-photos/karakonjul-1200.avif' },
      { width: 1254, src: '/assets/images/product-photos/karakonjul-1254.avif' },
    ],
    webp: [
      { width: 480, src: '/assets/images/product-photos/karakonjul-480.webp' },
      { width: 768, src: '/assets/images/product-photos/karakonjul-768.webp' },
      { width: 1200, src: '/assets/images/product-photos/karakonjul-1200.webp' },
      { width: 1254, src: '/assets/images/product-photos/karakonjul-1254.webp' },
    ],
  },
  '/assets/images/product-photos/little-karakonjul.png': {
    width: 1254,
    height: 1254,
    avif: [
      { width: 480, src: '/assets/images/product-photos/little-karakonjul-480.avif' },
      { width: 768, src: '/assets/images/product-photos/little-karakonjul-768.avif' },
      { width: 1200, src: '/assets/images/product-photos/little-karakonjul-1200.avif' },
      { width: 1254, src: '/assets/images/product-photos/little-karakonjul-1254.avif' },
    ],
    webp: [
      { width: 480, src: '/assets/images/product-photos/little-karakonjul-480.webp' },
      { width: 768, src: '/assets/images/product-photos/little-karakonjul-768.webp' },
      { width: 1200, src: '/assets/images/product-photos/little-karakonjul-1200.webp' },
      { width: 1254, src: '/assets/images/product-photos/little-karakonjul-1254.webp' },
    ],
  },
  '/assets/images/product-photos/macho-heaven.png': {
    width: 1254,
    height: 1254,
    avif: [
      { width: 480, src: '/assets/images/product-photos/macho-heaven-480.avif' },
      { width: 768, src: '/assets/images/product-photos/macho-heaven-768.avif' },
      { width: 1200, src: '/assets/images/product-photos/macho-heaven-1200.avif' },
      { width: 1254, src: '/assets/images/product-photos/macho-heaven-1254.avif' },
    ],
    webp: [
      { width: 480, src: '/assets/images/product-photos/macho-heaven-480.webp' },
      { width: 768, src: '/assets/images/product-photos/macho-heaven-768.webp' },
      { width: 1200, src: '/assets/images/product-photos/macho-heaven-1200.webp' },
      { width: 1254, src: '/assets/images/product-photos/macho-heaven-1254.webp' },
    ],
  },
  '/assets/images/product-photos/rockroach.png': {
    width: 1254,
    height: 1254,
    avif: [
      { width: 480, src: '/assets/images/product-photos/rockroach-480.avif' },
      { width: 768, src: '/assets/images/product-photos/rockroach-768.avif' },
      { width: 1200, src: '/assets/images/product-photos/rockroach-1200.avif' },
      { width: 1254, src: '/assets/images/product-photos/rockroach-1254.avif' },
    ],
    webp: [
      { width: 480, src: '/assets/images/product-photos/rockroach-480.webp' },
      { width: 768, src: '/assets/images/product-photos/rockroach-768.webp' },
      { width: 1200, src: '/assets/images/product-photos/rockroach-1200.webp' },
      { width: 1254, src: '/assets/images/product-photos/rockroach-1254.webp' },
    ],
  },
  '/assets/images/product-photos/twin-bliss.png': {
    width: 1254,
    height: 1254,
    avif: [
      { width: 480, src: '/assets/images/product-photos/twin-bliss-480.avif' },
      { width: 768, src: '/assets/images/product-photos/twin-bliss-768.avif' },
      { width: 1200, src: '/assets/images/product-photos/twin-bliss-1200.avif' },
      { width: 1254, src: '/assets/images/product-photos/twin-bliss-1254.avif' },
    ],
    webp: [
      { width: 480, src: '/assets/images/product-photos/twin-bliss-480.webp' },
      { width: 768, src: '/assets/images/product-photos/twin-bliss-768.webp' },
      { width: 1200, src: '/assets/images/product-photos/twin-bliss-1200.webp' },
      { width: 1254, src: '/assets/images/product-photos/twin-bliss-1254.webp' },
    ],
  },
  '/assets/images/product-photos/white-pearl.png': {
    width: 1254,
    height: 1254,
    avif: [
      { width: 480, src: '/assets/images/product-photos/white-pearl-480.avif' },
      { width: 768, src: '/assets/images/product-photos/white-pearl-768.avif' },
      { width: 1200, src: '/assets/images/product-photos/white-pearl-1200.avif' },
      { width: 1254, src: '/assets/images/product-photos/white-pearl-1254.avif' },
    ],
    webp: [
      { width: 480, src: '/assets/images/product-photos/white-pearl-480.webp' },
      { width: 768, src: '/assets/images/product-photos/white-pearl-768.webp' },
      { width: 1200, src: '/assets/images/product-photos/white-pearl-1200.webp' },
      { width: 1254, src: '/assets/images/product-photos/white-pearl-1254.webp' },
    ],
  },
  '/assets/images/spirit-photos/bp-spirit-1.png': {
    width: 1822,
    height: 863,
    avif: [
      { width: 480, src: '/assets/images/spirit-photos/bp-spirit-1-480.avif' },
      { width: 768, src: '/assets/images/spirit-photos/bp-spirit-1-768.avif' },
      { width: 1200, src: '/assets/images/spirit-photos/bp-spirit-1-1200.avif' },
      { width: 1600, src: '/assets/images/spirit-photos/bp-spirit-1-1600.avif' },
      { width: 1822, src: '/assets/images/spirit-photos/bp-spirit-1-1822.avif' },
    ],
    webp: [
      { width: 480, src: '/assets/images/spirit-photos/bp-spirit-1-480.webp' },
      { width: 768, src: '/assets/images/spirit-photos/bp-spirit-1-768.webp' },
      { width: 1200, src: '/assets/images/spirit-photos/bp-spirit-1-1200.webp' },
      { width: 1600, src: '/assets/images/spirit-photos/bp-spirit-1-1600.webp' },
      { width: 1822, src: '/assets/images/spirit-photos/bp-spirit-1-1822.webp' },
    ],
  },
  '/assets/images/spirit-photos/bp-spirit-2.png': {
    width: 1254,
    height: 1254,
    avif: [
      { width: 480, src: '/assets/images/spirit-photos/bp-spirit-2-480.avif' },
      { width: 768, src: '/assets/images/spirit-photos/bp-spirit-2-768.avif' },
      { width: 1200, src: '/assets/images/spirit-photos/bp-spirit-2-1200.avif' },
      { width: 1254, src: '/assets/images/spirit-photos/bp-spirit-2-1254.avif' },
    ],
    webp: [
      { width: 480, src: '/assets/images/spirit-photos/bp-spirit-2-480.webp' },
      { width: 768, src: '/assets/images/spirit-photos/bp-spirit-2-768.webp' },
      { width: 1200, src: '/assets/images/spirit-photos/bp-spirit-2-1200.webp' },
      { width: 1254, src: '/assets/images/spirit-photos/bp-spirit-2-1254.webp' },
    ],
  },
  '/assets/images/spirit-photos/bp-spirit-3.png': {
    width: 1024,
    height: 1536,
    avif: [
      { width: 480, src: '/assets/images/spirit-photos/bp-spirit-3-480.avif' },
      { width: 768, src: '/assets/images/spirit-photos/bp-spirit-3-768.avif' },
      { width: 1024, src: '/assets/images/spirit-photos/bp-spirit-3-1024.avif' },
    ],
    webp: [
      { width: 480, src: '/assets/images/spirit-photos/bp-spirit-3-480.webp' },
      { width: 768, src: '/assets/images/spirit-photos/bp-spirit-3-768.webp' },
      { width: 1024, src: '/assets/images/spirit-photos/bp-spirit-3-1024.webp' },
    ],
  },
};
